import { useAuthStore } from '@milestone-portal/context/useAuthStore';
import { LoginSearchSchema } from '@milestone-portal/schema/search.schema';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { Login } from './-components/Login';
import { LoginContext } from './-logic/LoginContext';
import { useLogin } from './-logic/useLogin';

export const Route = createFileRoute('/login/')({
  beforeLoad: () => {
    const user = useAuthStore.getState().authData?.user;
    if (user) {
      throw redirect({
        replace: true,
        to: '/profile',
      });
    }
  },
  component: LoginPage,
  validateSearch: zodValidator(LoginSearchSchema),
});

function LoginPage() {
  return (
    <LoginContext.Provider value={useLogin()}>
      <Login />
    </LoginContext.Provider>
  );
}
